var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import LoginApi from '../api/LoginApi';
import { proxyServer, channelKey, channelKeys } from '../const/app';
import { localStore } from 'mutants-microfx';
import tools from '../util/tools';
var emptyChannel = {
    throughProxy: false,
    targetURL: 'http://t.chanjet.com/tplus/',
};
var userHttpDomain = ['https://t.chanjet.com', 'https://xjhwt.chanjet.com'];
var Channel = /** @class */ (function () {
    function Channel(targetURL) {
        this.targetURL = Channel.filterURL(targetURL);
        if (targetURL.indexOf(proxyServer) > -1) {
            this.throughProxy = true;
        }
        else {
            this.throughProxy = false;
        }
    }
    Channel.filterURL = function (targetURL) {
        return targetURL;
    };
    Channel.getChannel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var targetURL, channel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, LoginApi.getTargetURL()];
                    case 1:
                        targetURL = _a.sent();
                        channel = new Channel(targetURL);
                        channel.cache();
                        return [2 /*return*/, channel];
                }
            });
        });
    };
    Channel.setChannel = function (targetURL) {
        var channel = new Channel(targetURL);
        channel.cache();
        return channel;
    };
    //缓存数据
    Channel.prototype.cache = function () {
        var _this = this;
        localStore.set(channelKey, this);
        channelKeys.forEach(function (channelKey) {
            if (!tools.isNull(_this[channelKey])) {
                localStore.set(channelKey, _this[channelKey]);
            }
        });
    };
    Channel.cache = function (obj) {
        var _this = this;
        localStore.set(channelKey, obj);
        channelKeys.forEach(function (channelKey) {
            if (!tools.isNull(_this[channelKey])) {
                localStore.set(channelKey, _this[channelKey]);
            }
        });
    };
    //恢复数据
    Channel.restore = function () {
        // let channel =  localStore.get(channelKey);
        // if(channel == null || channel == undefined){
        //   channel = emptyChannel;
        // }
        // return channel;
        var targetURL = localStore.get('targetURL');
        if (!tools.isNull(targetURL)) {
            var cacheObj_1 = {};
            channelKeys.forEach(function (key) {
                cacheObj_1[key] = localStore.get(key);
            });
            return cacheObj_1;
        }
        return emptyChannel;
    };
    //清空数据
    Channel.clear = function () {
        localStore.remove(channelKey);
        channelKeys.forEach(function (key) {
            localStore.remove(key);
        });
    };
    return Channel;
}());
export default Channel;

//# sourceMappingURL=Channel.js.map
